import BannerTitle from './banner-title';
import Header from '../header';

import './banner.scss';

export default function Banner() {
  return (
    <div className="banner">
      <div className="banner-info">
        <Header />
        <BannerTitle />
      </div>
    </div>
  );
}
